import vergabeVerbisTabsJson from './vergabe-verbis-tabs.json'
import vergabeKompetenzfeststellungTabsJson from './vergabe-kompetenzfeststellung-tabs.json'
import vergabeKompetenzbilanzierungTabsJson from './vergabe-kompetenzbilanzierung-tabs.json'
import vergabeAufnahmePotenzialanalyseTabsJson from './vergabe-aufnahme-potenzialanalyse-tabs.json'

import type { TabsConfig } from '@/core/templates/types'

export const vergabeVerbisTabs = (vergabeVerbisTabsJson as TabsConfig).tabs
export const vergabeAufnahmePotenzialanalyseTabs = (vergabeAufnahmePotenzialanalyseTabsJson as TabsConfig).tabs
export const vergabeKompetenzfeststellungTabs = (vergabeKompetenzfeststellungTabsJson as TabsConfig).tabs
export const vergabeKompetenzbilanzierungTabs = (vergabeKompetenzbilanzierungTabsJson as TabsConfig).tabs
export { default as massnahmeDetailsVergabeForm } from './massnahme-details-vergabe'
